<template>
  <div class="coproducer-modal">
    <bp-input
      v-model="form.email"
      required
      class="mb-5"
      label="E-mail do Coprodutor"
      placeholder="Digite o e-mail"
      description="O Coprodutor precisa possuir cadastro completo utilizando este e-mail."
    />
    <bp-select
      v-model="form.qty_months"
      required
      class="mb-5"
      label="Tempo de contrato"
      placeholder="Selecionar um período"
      description="Após esse período, o Coprodutor deixará de receber comissão."
      :options="[
        { id: 1, name: '1 mês' },
        { id: 2, name: '2 meses' },
        { id: 3, name: '3 meses' },
        { id: 6, name: '6 meses' },
        { id: 12, name: '1 ano' },
        { id: 24, name: '2 anos' },
        { id: 120, name: '10 anos' }
      ]"
    />
    <h4 class="mb-5">Porcentagem das comissões</h4>
    <bp-input
      v-model="form.tax_product"
      money
      required
      class="mb-5"
      pre-icon="fa-light fa-percent"
      label="Porcentagem para vendas do produtor"
      :money-config="{
        decimal: ',',
        thousands: '.',
        prefix: '',
        precision: 1
      }"
      :validation="taxValidation"
    />

    <bp-switch
      v-model="form.payment_recurrence"
      label="Continuar pagando comissões a Coprodutores, após o término do contrato, pelas recorrências de vendas feitas durante a vigência dele."
    />

    <template v-if="!form.id">
      <hr class="my-5 border-neutral-048" />
      <bp-header
        size="md"
        class="mb-5"
        title="Termos de uso da Coprodução"
        subtitle="Ao estabelecerem uma relação de Coprodução, Produtor e Coprodutor reconhecem e concordam com as regras e disposições da Blitzpay, que estão descritas abaixo:"
      />
      <coproduction-terms class="mb-5" />
      <bp-checkbox
        id="check"
        v-model="form.accepted_terms"
        name="Li e aceito os termos e condições da coprodução."
      />
    </template>

    <div
      class="d-flex flex-column flex-lg-row justify-content-lg-end gap-5 pt-7"
    >
      <bp-button
        label="Cancelar"
        color="neutral"
        variant="filled-1"
        @click="$emit('close')"
      />
      <bp-button
        label="Salvar"
        class="order-0 order-lg-1"
        :loading="loading"
        :disabled="!isvalid"
        @click="submit"
      />
    </div>
  </div>
</template>

<script>
import { formatPercentage } from "@/functions/formatting";
import { formFields } from "@/functions/helpers";
import { lessOrEqualThan, moreThan } from "@/functions/validation";
import moment from "moment";
import CoproductionTerms from "./CoproductionTerms.vue";
export default {
  components: {
    CoproductionTerms
  },
  props: {
    productId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      loading: false,
      ...formFields(
        [
          "id",
          "email",
          "qty_months",
          "tax_product",
          "payment_recurrence",
          "contract_time"
        ],
        {
          accepted_terms: "",
          payment_recurrence: false,
          ...this.data
        }
      ),
      taxValidation: [
        moreThan(
          0,
          min => `A comissão deve ser maior que ${formatPercentage(min)}`
        ),
        lessOrEqualThan(
          99,
          max => `A comissão deve ser menor ou igual a ${formatPercentage(max)}`
        )
      ]
    };
  },
  computed: {
    isvalid() {
      return (
        this.form.email &&
        this.form.qty_months &&
        this.form.tax_product &&
        this.form.tax_product > 0 &&
        this.form.tax_product <= 99 &&
        !!this.form.accepted_terms
      );
    }
  },
  methods: {
    async submit() {
      this.loading = true;

      try {
        const { payment_recurrence, tax_product, email } = this.form;
        const contract_time =
          this.form.qty_months === -1
            ? null
            : moment()
                .add(this.form.qty_months, "months")
                .format("YYYY-MM-DD");

        const { data: coproducer } = await this.$store
          .dispatch("user/postCoProducer", email)
          .catch(error => {
            this.errors = error.response.data;
          });

        await this.$store.dispatch("user/postCoProducerProduct", {
          co_producer_id: coproducer.id,
          product_id: this.productId,
          contract_time,
          payment_recurrence,
          tax_product
        });

        this.$message.success("Coprodutor cadastrado com sucesso!");
        this.$emit("close");
        this.$emit("refresh");
      } catch (error) {
        if (this.errors.email.length) {
          this.$message.error(this.errors.email[0]);
          return;
        } else this.$message.error("Erro ao cadastrar co-produtor.");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
